<template>
    <!-- lc  detail： -->
    <my-dialog @hideMask="hideMaskForLCDetail" :dialogFlag="dialogFlagForLCDetail" width="770px" p_lr="0">
        <div class="dialog_inner_container_for_lc_detail">
            <div class="dialog_inner_container_for_lc_detail_header">{{title}}</div>
            <div class="dialog_inner_container_for_lc_detail_body">
                <div class="dialog_inner_container_for_lc_detail_detail_top">
                    <div class="dialog_inner_container_for_lc_detail_detail_top_title">
                        基本信息
                    </div>
                    <div class="dialog_inner_container_for_lc_detail_detail_top_body">
                        <div class="dialog_inner_container_for_lc_detail_detail_top_body_inner_item" v-for="item in objectOfLCDetail.detailInfoList" :key="item.title">
                            <div class="dialog_inner_container_for_lc_detail_detail_top_body_inner_item_title">【{{item.title}}】：</div>
                            <div class="dialog_inner_container_for_lc_detail_detail_top_body_inner_item_body">
                                <span :class="['first_value', item.hasOwnProperty('secondValue')? 'has_border_right': '']">{{item.firstValue? item.firstValue: '- -'}}</span>
                                <span class="second_value" :style="{color: item.secondColor}" v-if="item.hasOwnProperty('secondValue')">{{item.secondValue? item.secondValue: '- -'}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="dialog_inner_container_for_lc_detail_detail_bottom">
                    <div class="dialog_inner_container_for_lc_detail_detail_bottom_left">
                        <div class="dialog_inner_container_for_lc_detail_detail_bottom_inner_box_title">主讲</div>
                        <div class="dialog_inner_container_for_lc_detail_detail_bottom_inner_box_body">
                            <div class="dialog_inner_container_for_lc_detail_detail_bottom_inner_box_body_inner">
                                <!-- real item: -->
                                <div class="dialog_inner_container_for_lc_detail_detail_bottom_inner_box_body_inner_item" v-for="item in objectOfLCDetail.roomList" :key="item.roomName" v-show="item.roomType === 1">
                                    <div class="dialog_inner_container_for_lc_detail_detail_bottom_inner_box_body_inner_item_title">{{item.roomName}}</div>
                                    <div class="dialog_inner_container_for_lc_detail_detail_bottom_inner_box_body_inner_item_body">
                                        <p class="dialog_inner_container_for_lc_detail_detail_bottom_inner_box_body_inner_item_body_management">
                                            <span class="person_type">{{ item.classType ? '【导播】' : '【管理员】' }}：</span>
                                            <span class="person_name">{{item.adminName? item.adminName: '- -'}}</span>
                                            <span class="person_phone">{{item.adminPhone? item.adminPhone: '- -'}}</span>
                                        </p>
                                        <p class="dialog_inner_container_for_lc_detail_detail_bottom_inner_box_body_inner_item_body_maintain">
                                            <span class="person_type">{{ item.classType ? '【专员】' : '【维护员】' }}：</span>
                                            <span class="person_name">{{item.defendName? item.defendName: '- -'}}</span>
                                            <span class="person_phone">{{item.defendPhone? item.defendPhone: '- -'}}</span>
                                        </p>
                                    </div>
                                </div>
                                <div class="empty_for_class_rooom_list" v-if="!teacherRoomNum">
                                    抱歉，暂无教室哦
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="dialog_inner_container_for_lc_detail_detail_bottom_right">
                        <div class="dialog_inner_container_for_lc_detail_detail_bottom_inner_box_title">听课/收视<span class="dialog_inner_container_for_lc_detail_detail_bottom_inner_box_title_num">（{{watchRoomNum}}）</span></div>
                        <div class="dialog_inner_container_for_lc_detail_detail_bottom_inner_box_body">
                            <div class="dialog_inner_container_for_lc_detail_detail_bottom_inner_box_body_inner">
                                <!-- real item: -->
                                <div class="dialog_inner_container_for_lc_detail_detail_bottom_inner_box_body_inner_item" v-for="item in objectOfLCDetail.roomList" :key="item.roomName" v-show="item.roomType === 2">
                                    <div class="dialog_inner_container_for_lc_detail_detail_bottom_inner_box_body_inner_item_title">{{item.roomName}}</div>
                                    <div class="dialog_inner_container_for_lc_detail_detail_bottom_inner_box_body_inner_item_body">
                                        <p class="dialog_inner_container_for_lc_detail_detail_bottom_inner_box_body_inner_item_body_management">
                                            <span class="person_type"> {{ item.classType ? '【导播】' : '【管理员】' }}：</span>
                                            <span class="person_name">{{item.adminName? item.adminName: '- -'}}</span>
                                            <span class="person_phone">{{item.adminPhone? item.adminPhone: '- -'}}</span>
                                        </p>
                                        <p class="dialog_inner_container_for_lc_detail_detail_bottom_inner_box_body_inner_item_body_maintain">
                                            <span class="person_type">{{ item.classType ? '【专员】' : '【维护员】：' }}：</span>
                                            <span class="person_name">{{item.defendName? item.defendName: '- -'}}</span>
                                            <span class="person_phone">{{item.defendPhone? item.defendPhone: '- -'}}</span>
                                        </p>
                                    </div>
                                </div>
                                <div class="empty_for_class_rooom_list" v-if="!watchRoomNum">
                                    抱歉，暂无教室哦
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="loading_mask" v-if="dialogLoadingForLCDetail">
                    <a-spin />
                </div>
            </div>
        </div>
    </my-dialog>   
</template>

<script>
export default {
    components: {
        "my-dialog": () => import("../../components/my_dialog")
    },
    props: {
        title: {
            type: String,
            default: '基本信息'
        },
        dialogFlagForLCDetail: {
            type: Boolean,
            default: false
        },
        objectOfLCDetail: {
            type: Object,
            default: {
                detailInfoList: [
                    {
                        title: "课程",
                        firstValue: "",
                        secondValue: "",
                        secondColor: "#669CFF"
                    },
                    {
                        title: "类型",
                        firstValue: "同步课堂",
                        secondValue: "",
                        secondColor: "##474C59"
                    },
                    {
                        title: "主讲",
                        firstValue: "",
                        secondValue: "",
                        secondColor: "#669CFF"
                    },
                    {
                        title: "时间",
                        firstValue: ""
                    }
                ],
                roomList: []
            }
        },
        teacherRoomNum: {
            type: Number,
            default: 0
        },
        watchRoomNum: {
            type: Number,
            default: 0
        },
        dialogLoadingForLCDetail: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        hideMaskForLCDetail() {
            this.$emit('hideMaskForLCDetail');
        }
    }
}
</script>

<style lang="scss">
    @mixin dialogTitle($color) {
        width: 100%;
        height: 60px;
        line-height: 60px;
        font-weight: bold;
        color: $color;
        font-size: 16px;
        border-radius: 10px 10px 0 0;
        padding: 0 30px;
        border-bottom: 1px solid #E7E7E7;
    }
    @mixin verticalAndCrosswiseCenter {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    // lc detail:
    .dialog_inner_container_for_lc_detail {
        .dialog_inner_container_for_lc_detail_header {
            @include dialogTitle(#222);
        }
        .dialog_inner_container_for_lc_detail_body {
            width: 100%;
            height: auto;
            padding: 20px 30px 30px;
            border-radius: 0 0 10px 10px;
            position: relative;
            .dialog_inner_container_for_lc_detail_detail_top {
                border-bottom: 1px solid #E7E7E7;
                .dialog_inner_container_for_lc_detail_detail_top_title {
                    width: 100%;
                    padding-left: 10px;
                    position: relative;
                    font-weight: bold;
                    &::before {
                        content: "";
                        width: 3px;
                        height: 16px;
                        background-color: #5F98FF;
                        border-radius: 2px;
                        position: absolute;
                        left: 0;
                        top: 50%;
                        transform: translateY(-50%);
                    }
                }
                .dialog_inner_container_for_lc_detail_detail_top_body {
                    width: 100%;
                    height: auto;
                    padding: 17px 18px 20px;
                    .dialog_inner_container_for_lc_detail_detail_top_body_inner_item {
                        width: 100%;
                        height: 20px;
                        display: flex;
                        align-items: center;
                        margin-top: 15px;
                        color: #474C59;
                        &:nth-of-type(1) {
                            margin-top: 5px;
                        }
                        .dialog_inner_container_for_lc_detail_detail_top_body_inner_item_title {
                        }
                        .dialog_inner_container_for_lc_detail_detail_top_body_inner_item_body {
                            display: flex;
                            align-items: center;
                            height: 100%;
                            font-size: 13px;
                            .first_value {
                                height: 100%;
                                padding-right: 10px;
                                margin-right: 10px;
                                font-size: 13px;
                                max-width: 300px;
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                &.has_border_right {
                                    border-right: 1px solid #7C7B87;
                                }
                            }
                            .second_value {
                            }
                        }
                    }
                }
            }
            .dialog_inner_container_for_lc_detail_detail_bottom {
                width: 100%;
                height: 250px;
                display: flex;
                padding-top: 20px;
                .dialog_inner_container_for_lc_detail_detail_bottom_left,
                .dialog_inner_container_for_lc_detail_detail_bottom_right {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    .dialog_inner_container_for_lc_detail_detail_bottom_inner_box_title {
                        width: 100%;
                        height: 20px;
                        padding-left: 10px;
                        position: relative;
                        font-weight: bold;
                        .dialog_inner_container_for_lc_detail_detail_bottom_inner_box_title_num {
                            color: #FE7C14;
                        }
                        &::before {
                            content: "";
                            width: 3px;
                            height: 16px;
                            background-color: #5F98FF;
                            border-radius: 2px;
                            position: absolute;
                            left: 0;
                            top: 50%;
                            transform: translateY(-50%);
                        }
                    }
                    .dialog_inner_container_for_lc_detail_detail_bottom_inner_box_body {
                        flex: 1;
                        height: 210px;
                        padding: 18px;
                        padding-bottom: 10px;
                        .dialog_inner_container_for_lc_detail_detail_bottom_inner_box_body_inner {
                            width: 100%;
                            height: 100%;
                            overflow-y: auto;
                            .dialog_inner_container_for_lc_detail_detail_bottom_inner_box_body_inner_item {
                                width: 100%;
                                height: 107px;
                                border-left: 3px solid #5F98FF;
                                background-color: #F2F3FA;
                                margin-bottom: 20px;
                                display: flex;
                                flex-direction: column;
                                &:nth-last-child(1) {
                                    margin-bottom: 0;
                                }
                                .dialog_inner_container_for_lc_detail_detail_bottom_inner_box_body_inner_item_title {
                                    width: 100%;
                                    height: 40px;
                                    line-height: 40px;
                                    font-size: 14px;
                                    font-weight: 500;
                                    color: #0C0B22;
                                    padding: 0 18px;
                                }
                                .dialog_inner_container_for_lc_detail_detail_bottom_inner_box_body_inner_item_body {
                                    flex: 1;
                                    display: flex;
                                    flex-direction: column;
                                    font-size: 13px;
                                    .dialog_inner_container_for_lc_detail_detail_bottom_inner_box_body_inner_item_body_management,
                                    .dialog_inner_container_for_lc_detail_detail_bottom_inner_box_body_inner_item_body_maintain {
                                        flex:1;
                                        display: flex;
                                        align-items: center;
                                        padding-left: 10px;
                                    }
                                    .dialog_inner_container_for_lc_detail_detail_bottom_inner_box_body_inner_item_body_management {

                                    }
                                    .dialog_inner_container_for_lc_detail_detail_bottom_inner_box_body_inner_item_body_maintain {

                                    }
                                    .person_phone {
                                        color: #74A6FE;
                                        margin-left: 10px;
                                    }
                                }
                            }
                            .empty_for_class_rooom_list {
                                width: 100%;
                                height: 100%;
                                background-color: #F5F5F5;
                                border-radius: 10px;
                                @include verticalAndCrosswiseCenter();
                                color: #AAA;
                            }
                        }
                    }
                }
            }            
        }
    }
    .loading_mask {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        @include verticalAndCrosswiseCenter();
        background-color: rgba(255, 255, 255, 0.7);
        cursor: not-allowed;
    }
</style>